// extracted by mini-css-extract-plugin
export default {"apkUpdate":"ApkUpdate_apkUpdate__NCc5R"};